import {
  Component,
  OnInit
} from '@angular/core';
import { ProductService } from '../../../shared/services/product.service';
import { AppUtilService } from '../../../app-util.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {

  public services: any[] = [];

  constructor(private productService: ProductService, public appUtilService: AppUtilService, public router: Router) {
  }

  ngOnInit(): void {
    this.appUtilService.setBrowserTitle('About Us');
    this.services = this.productService.getServices();
  }

}
